import React from 'react';
import { NavLink, Outlet, useParams } from 'react-router-dom';
import { Workflow, PlayCircle, GitGraph } from 'lucide-react';

export default function MainLayout() {
  const FLOW_BASE = '/my-quant-flows';
  const { workflowId } = useParams();

  // Determine if we are in a workflow context
  const isWorkflowActive = !!workflowId;

  return (
    <div className="flex h-full w-full overflow-hidden bg-[var(--bg-app)] text-[var(--text-primary)]">
      {/* Sidebar */}
      <aside className="flex w-[240px] flex-col border-r border-[var(--border-subtle)] bg-[var(--bg-panel)]">
        {/* Brand */}
        <div className="flex h-14 items-center border-b border-[var(--border-subtle)] px-4">
          <Workflow className="mr-2 h-5 w-5 text-[var(--accent-blue)]" />
          <span className="text-lg font-bold tracking-tight">K-Quant</span>
        </div>

        {/* Navigation */}
        <nav className="flex-1 space-y-1 overflow-y-auto p-3">
          <div className="mt-2 mb-2 px-3 text-xs font-semibold tracking-wider text-[var(--text-secondary)] uppercase">
            Platform
          </div>

          <NavItem to={FLOW_BASE} end icon={<Workflow size={18} />} label="Overview" />

          {isWorkflowActive && (
            <>
              <div className="my-4 border-t border-[var(--border-subtle)]" />
              <div className="mb-2 px-3 text-xs font-semibold tracking-wider text-[var(--text-secondary)] uppercase">
                Current Strategy
              </div>
              <NavItem to={`${FLOW_BASE}/editor/${workflowId}`} icon={<GitGraph size={18} />} label="DAG Studio" />
              <NavItem to={`${FLOW_BASE}/backtest/${workflowId}`} icon={<PlayCircle size={18} />} label="Backtest & Debug" />
            </>
          )}
        </nav>

        {/* Footer */}
        <div className="p-3 border-t border-[var(--border-subtle)]">
          <div className="flex items-center p-2 rounded-md hover:bg-[var(--bg-panel-hover)] cursor-pointer transition-colors">
            <div className="w-8 h-8 rounded-full bg-[var(--accent-purple)] flex items-center justify-center text-xs font-bold text-white">
              KQ
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium">User</p>
              <p className="text-xs text-[var(--text-secondary)]">Pro Plan</p>
            </div>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 flex flex-col min-w-0 overflow-hidden bg-[var(--bg-app)]">
        <Outlet />
      </main>
    </div>
  );
}

function NavItem({ to, icon, label, end = false }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
          isActive
            ? 'bg-[var(--accent-blue-dim)] text-[var(--accent-blue)]'
            : 'text-[var(--text-secondary)] hover:bg-[var(--bg-panel-hover)] hover:text-[var(--text-primary)]'
        }`
      }
    >
      <span className="mr-3">{icon}</span>
      {label}
    </NavLink>
  );
}
